/* ============================================================
   ETCHWELL — interactions
   Lenis + GSAP/ScrollTrigger/SplitText + Three.js particles
   ============================================================ */
const REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
const FINE = matchMedia('(hover:hover) and (pointer:fine)').matches;
const MOBILE = matchMedia('(max-width:680px)').matches;
gsap.registerPlugin(ScrollTrigger, SplitText);

/* ---------------- Preloader ---------------- */
(function preloader(){
  const mark = document.getElementById('preMark');
  const bar = document.getElementById('preBar');
  const pre = document.getElementById('preloader');
  if(!mark || !pre){ startHero(); return; } // pages without a preloader (e.g. product page)
  mark.innerHTML = [...'Etchwell'].map(c=>`<span>${c}</span>`).join('');
  const letters = mark.querySelectorAll('span');
  if(REDUCED){ pre.remove(); startHero(); return; }
  const count = document.createElement('div'); count.className='preloader__count'; count.textContent='0'; pre.appendChild(count);
  const o={v:0};
  gsap.timeline()
    .to(letters,{y:0,duration:.9,ease:'expo.out',stagger:.06})
    .to(o,{v:100,duration:1.0,ease:'power1.inOut',onUpdate:()=>count.textContent=Math.round(o.v)},0)
    .to(bar,{width:'100%',duration:1.0,ease:'power2.inOut'},0)
    .to([...letters,count],{autoAlpha:0,duration:.4,ease:'power2.in'},'+=.2')
    .to(pre,{yPercent:-100,duration:.9,ease:'expo.inOut',onComplete:()=>pre.remove()},'-=.15')
    .add(()=>startHero(),'-=.55');
})();

/* ---------------- Lenis smooth scroll ---------------- */
let lenis;
if(!REDUCED){
  lenis = new Lenis({duration:1.1,easing:t=>Math.min(1,1.001-Math.pow(2,-10*t)),smoothWheel:true,syncTouch:false});
  lenis.on('scroll',ScrollTrigger.update);
  window.__lenis = lenis; // dev/test hook
  gsap.ticker.add(t=>lenis.raf(t*1000));
  gsap.ticker.lagSmoothing(0);
}
document.querySelectorAll('a[href^="#"]').forEach(a=>{
  a.addEventListener('click',e=>{
    const t=document.querySelector(a.getAttribute('href'));
    if(!t)return;e.preventDefault();
    lenis ? lenis.scrollTo(t,{offset:-70,duration:1.2}) : t.scrollIntoView({behavior:'smooth'});
  });
});

/* ---------------- Nav scroll state ---------------- */
const nav=document.getElementById('nav');
ScrollTrigger.create({start:'top -60',onUpdate:s=>nav.classList.toggle('nav--scrolled',s.scroll()>60)});

/* ---------------- Mobile menu ---------------- */
(function(){
  const burger=document.querySelector('.nav__burger');if(!burger)return;
  const logo=document.querySelector('.nav__logo')?.outerHTML||'';
  const links=[...document.querySelectorAll('.nav__links a')].map(a=>`<a href="${a.getAttribute('href')}">${a.textContent}</a>`).join('');
  const menu=document.createElement('div');menu.className='mobile-menu';
  menu.innerHTML=`<div class="mm-head">${logo}<button class="mm-close" aria-label="Close menu">&times;</button></div><nav class="mm-links">${links}</nav><a href="product.html" class="mm-cta">Customize yours &rarr;</a>`;
  document.body.appendChild(menu);
  const open=()=>{menu.classList.add('open');burger.classList.add('active');lenis&&lenis.stop();};
  const close=()=>{menu.classList.remove('open');burger.classList.remove('active');lenis&&lenis.start();};
  burger.addEventListener('click',()=>menu.classList.contains('open')?close():open());
  menu.querySelector('.mm-close').addEventListener('click',close);
  menu.querySelectorAll('.mm-links a,.mm-cta').forEach(a=>a.addEventListener('click',close));
})();

/* ---------------- Custom cursor + magnetic ---------------- */
if(FINE){
  const dot=document.querySelector('.cursor'),ring=document.querySelector('.cursor-ring');
  const dx=gsap.quickTo(dot,'x',{duration:.15,ease:'power3'}),dy=gsap.quickTo(dot,'y',{duration:.15,ease:'power3'});
  const rx=gsap.quickTo(ring,'x',{duration:.45,ease:'power3'}),ry=gsap.quickTo(ring,'y',{duration:.45,ease:'power3'});
  addEventListener('pointermove',e=>{dx(e.clientX);dy(e.clientY);rx(e.clientX);ry(e.clientY);});
  document.querySelectorAll('[data-hover],a,button').forEach(el=>{
    el.addEventListener('pointerenter',()=>ring.classList.add('hover'));
    el.addEventListener('pointerleave',()=>ring.classList.remove('hover'));
  });
  // magnetic
  document.querySelectorAll('.btn,.nav__cta').forEach(btn=>{
    const xTo=gsap.quickTo(btn,'x',{duration:.5,ease:'power3'}),yTo=gsap.quickTo(btn,'y',{duration:.5,ease:'power3'});
    btn.addEventListener('pointermove',e=>{const r=btn.getBoundingClientRect();xTo((e.clientX-(r.left+r.width/2))*.35);yTo((e.clientY-(r.top+r.height/2))*.4);});
    btn.addEventListener('pointerleave',()=>{xTo(0);yTo(0);});
  });
}

/* ---------------- Hero reveal (called after preloader) ---------------- */
function startHero(){
  if(REDUCED){document.querySelectorAll('[data-reveal]').forEach(e=>{e.style.opacity=1;e.style.transform='none';});return;}
  document.fonts.ready.then(()=>{
    const split=new SplitText('.hero__title .ln',{type:'lines',linesClass:'split-line'});
    gsap.set('.split-line',{display:'block'});
    gsap.from(split.lines,{yPercent:100,opacity:0,duration:1.1,ease:'expo.out',stagger:.12});
    const emEl=document.querySelector('.hero__title em');
    if(emEl && window.SplitText){
      const cs=new SplitText(emEl,{type:'chars'});
      gsap.set(emEl,{display:'inline-block'});
      gsap.to(cs.chars,{yPercent:-16,duration:1.5,ease:'sine.inOut',delay:1.6,
        stagger:{each:.06,repeat:-1,yoyo:true}});
    }
  });
  gsap.to('.hero .hero__copy [data-reveal], .hero .hero__media',{opacity:1,y:0,duration:1,ease:'power3.out',stagger:.12,delay:.25});
  gsap.from('.hero__media img',{scale:1.25,duration:1.6,ease:'power3.out',delay:.25});
}

/* ---------------- Generic scroll reveals ---------------- */
gsap.utils.toArray('[data-reveal]').forEach(el=>{
  if(el.closest('.hero'))return;
  if(el.matches('h2') && !REDUCED) return; // headings get word-by-word reveal below
  gsap.to(el,{opacity:1,y:0,duration:.9,ease:'power3.out',
    scrollTrigger:{trigger:el,start:'top 86%'}});
});

/* word-by-word heading reveals */
if(!REDUCED && window.SplitText){
  gsap.utils.toArray('h2[data-reveal]').forEach(h=>{
    if(h.closest('.hero')) return;
    const sp=new SplitText(h,{type:'words'});
    gsap.set(h,{opacity:1,y:0});
    gsap.from(sp.words,{yPercent:118,opacity:0,duration:.95,ease:'power4.out',stagger:.05,
      scrollTrigger:{trigger:h,start:'top 88%'}});
  });
}

/* ---------------- Marquee ---------------- */
(function(){
  const inner=document.querySelector('.marquee__inner');if(!inner||REDUCED)return;
  const loop=gsap.to(inner,{xPercent:-50,ease:'none',duration:24,repeat:-1});
  if(lenis)lenis.on('scroll',({velocity})=>{const d=velocity>=0?1:-1;loop.timeScale(gsap.utils.clamp(.4,5,1+Math.abs(velocity)*.25)*d);});
})();

/* ---------------- Count-ups ---------------- */
gsap.utils.toArray('.stat').forEach(el=>{
  const end=+el.dataset.count,suffix=el.dataset.suffix||'',o={v:0};
  if(REDUCED){el.textContent=end.toLocaleString()+suffix;return;}
  ScrollTrigger.create({trigger:el,start:'top 88%',once:true,onEnter:()=>gsap.to(o,{v:end,duration:1.8,ease:'power2.out',onUpdate:()=>el.textContent=Math.floor(o.v).toLocaleString()+suffix})});
});

/* ---------------- Live engraving preview ---------------- */
(function engraver(){
  const input=document.getElementById('engraveInput');
  const text=document.getElementById('engraveText');
  const barrel=document.getElementById('penBarrel');
  const fonts=document.getElementById('engraveFonts');
  const swatches=document.getElementById('swatches');
  if(!input||!text)return;

  function fit(){
    const len=(input.value||'').length;
    text.textContent=input.value||'Your name';
    text.setAttribute('font-size', len>14 ? 22 : len>9 ? 27 : 32);
    if(!REDUCED){gsap.fromTo(text,{opacity:.2},{opacity:1,duration:.5,ease:'power2.out'});}
  }
  input.addEventListener('input',fit);

  fonts.addEventListener('click',e=>{
    const b=e.target.closest('button');if(!b)return;
    fonts.querySelectorAll('button').forEach(x=>x.setAttribute('aria-pressed',x===b));
    text.style.fontFamily=b.dataset.font;
    text.style.fontStyle=b.dataset.style;
  });

  function shade(hex,p){ // p<0 darker, p>0 lighter
    const n=parseInt(hex.slice(1),16);let r=n>>16,g=n>>8&255,b=n&255;
    const f=v=>Math.max(0,Math.min(255,Math.round(v+(p>0?(255-v):v)*p*(p>0?1:1))));
    r=Math.max(0,Math.min(255,Math.round(r+255*p*(p<0? r/255 : (255-r)/255)/(p<0?-1:1)*(p<0?-1:1))));
    // simpler robust shade:
    const adj=(v)=>Math.max(0,Math.min(255,Math.round(v*(1+p))));
    return '#'+[adj(n>>16),adj(n>>8&255),adj(n&255)].map(x=>x.toString(16).padStart(2,'0')).join('');
  }
  swatches.addEventListener('click',e=>{
    const b=e.target.closest('button');if(!b)return;
    swatches.querySelectorAll('button').forEach(x=>x.setAttribute('aria-pressed',x===b));
    const base=b.dataset.barrel;
    const grad=document.querySelector('#barrel');
    if(grad){grad.children[0].setAttribute('stop-color',shade(base,.35));grad.children[1].setAttribute('stop-color',base);grad.children[2].setAttribute('stop-color',shade(base,-.25));}
    text.style.fill = (base==='#d8a988'||base==='#8a9a7e') ? '#2a261f' : '#f3e7d8';
    if(!REDUCED)gsap.fromTo(barrel,{scaleX:.985,transformOrigin:'50% 50%'},{scaleX:1,duration:.5,ease:'back.out(2)'});
  });
  fit();
})();

/* ---------------- Three.js rose-gold particle field ---------------- */
(async function particles(){
  const canvas=document.getElementById('heroCanvas');
  if(!canvas||REDUCED||MOBILE)return; // skip on reduced-motion / phones (bg gradient remains)
  const THREE=await import('three'); // lazy-load so the opening animation never waits on the CDN

  const scene=new THREE.Scene();
  const camera=new THREE.PerspectiveCamera(60,innerWidth/innerHeight,.1,100);
  camera.position.z=18;
  const renderer=new THREE.WebGLRenderer({canvas,alpha:true,antialias:true});
  renderer.setPixelRatio(Math.min(devicePixelRatio,2));
  renderer.setSize(innerWidth,innerHeight);

  const COUNT=Math.min(2000, Math.floor(innerWidth*innerHeight/1100));
  const pos=new Float32Array(COUNT*3), sz=new Float32Array(COUNT);
  for(let i=0;i<COUNT;i++){
    pos[i*3]=(Math.random()-.5)*46; pos[i*3+1]=(Math.random()-.5)*30; pos[i*3+2]=(Math.random()-.5)*24;
    sz[i]=Math.random()*.10+.02;
  }
  const geo=new THREE.BufferGeometry();
  geo.setAttribute('position',new THREE.BufferAttribute(pos,3));
  geo.setAttribute('size',new THREE.BufferAttribute(sz,1));

  // soft round sprite
  const c=document.createElement('canvas');c.width=c.height=64;const ctx=c.getContext('2d');
  const g=ctx.createRadialGradient(32,32,0,32,32,32);g.addColorStop(0,'rgba(216,169,136,1)');g.addColorStop(.4,'rgba(192,138,106,.6)');g.addColorStop(1,'rgba(192,138,106,0)');
  ctx.fillStyle=g;ctx.fillRect(0,0,64,64);
  const tex=new THREE.CanvasTexture(c);

  const mat=new THREE.PointsMaterial({size:.30,map:tex,transparent:true,depthWrite:false,blending:THREE.AdditiveBlending,opacity:.55});
  const pts=new THREE.Points(geo,mat);
  scene.add(pts);

  const mouse={x:0,y:0,tx:0,ty:0};
  addEventListener('pointermove',e=>{mouse.tx=(e.clientX/innerWidth-.5);mouse.ty=(e.clientY/innerHeight-.5);});
  addEventListener('resize',()=>{camera.aspect=innerWidth/innerHeight;camera.updateProjectionMatrix();renderer.setSize(innerWidth,innerHeight);});

  let raf,visible=true,t=0;
  const io=new IntersectionObserver(es=>{visible=es[0].isIntersecting; if(visible) loop(); },{threshold:.01});
  io.observe(canvas);
  document.addEventListener('visibilitychange',()=>{if(document.hidden){cancelAnimationFrame(raf);}else if(visible){loop();}});

  function loop(){
    raf=requestAnimationFrame(loop);
    t+=.0016;
    mouse.x+=(mouse.tx-mouse.x)*.05; mouse.y+=(mouse.ty-mouse.y)*.05;
    pts.rotation.y=t*.4 + mouse.x*.5;
    pts.rotation.x=mouse.y*.3;
    camera.position.x+=(mouse.x*4-camera.position.x)*.04;
    camera.position.y+=(-mouse.y*3-camera.position.y)*.04;
    camera.lookAt(scene.position);
    renderer.render(scene,camera);
  }
  loop();
})();

/* ---------------- Scroll progress bar ---------------- */
(function(){
  const bar=document.createElement('div');bar.className='scroll-prog';document.body.appendChild(bar);
  ScrollTrigger.create({start:0,end:'max',onUpdate:s=>gsap.set(bar,{scaleX:s.progress})});
})();

/* ---------------- 3D tilt on collection cards ---------------- */
if(FINE && !REDUCED){
  document.querySelectorAll('.col-card').forEach(card=>{
    const rX=gsap.quickTo(card,'rotateX',{duration:.5,ease:'power3'});
    const rY=gsap.quickTo(card,'rotateY',{duration:.5,ease:'power3'});
    card.addEventListener('pointermove',e=>{const r=card.getBoundingClientRect();
      rY(((e.clientX-r.left)/r.width-.5)*10); rX(-((e.clientY-r.top)/r.height-.5)*10);});
    card.addEventListener('pointerleave',()=>{rX(0);rY(0);});
  });
}

/* ---------------- Cursor spotlight on dark sections ---------------- */
if(FINE){
  ['.personalize','.reviews'].forEach(sel=>{
    const sec=document.querySelector(sel);if(!sec)return;
    const glow=document.createElement('div');glow.className='sec-glow';sec.insertBefore(glow,sec.firstChild);
    sec.addEventListener('pointermove',e=>{const r=sec.getBoundingClientRect();
      glow.style.setProperty('--mx',(e.clientX-r.left)+'px');glow.style.setProperty('--my',(e.clientY-r.top)+'px');});
  });
}

/* ---------------- cinematic image parallax (Ken Burns) ---------------- */
if(!REDUCED){
  gsap.utils.toArray('.feature__media img,.about__media img').forEach(img=>{
    const sec=img.closest('section')||img;
    gsap.fromTo(img,{scale:1.18},{scale:1,ease:'none',
      scrollTrigger:{trigger:sec,start:'top bottom',end:'bottom top',scrub:true}});
  });
}

/* ---------------- refresh after load ---------------- */
addEventListener('load',()=>ScrollTrigger.refresh());
